import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { AppSumo } from './components/AppSumo/AppSumo';
import { GeneralBilling } from './components/GeneralBilling/GeneralBilling';

export const Billing: React.FC = (): JSX.Element => {
  const { user, org } = useSelector((state: RootState) => state.auth);

  const appSumoPermissionCheck =
    org?.acquisitionSource &&
    org.acquisitionSource === 'AppSumo' &&
    (user?.role === 'owner' || user?.role === 'superAdmin');

  const conditionalBilling = appSumoPermissionCheck ? (
    <AppSumo />
  ) : (
    <GeneralBilling />
  );

  return conditionalBilling;
};
